export const getCategoryForContract = (name: string): 'core' | 'proxy' | 'multisig' | 'utility' | 'liquidity' | 'charity' | 'other' => {
    const lowerName = name.toLowerCase();

    if (lowerName.includes('features') || lowerName.includes('controller')) return 'proxy';
    if (lowerName.includes('core') || lowerName.includes('multisigfactory') || lowerName.includes('timelockcontroller')) return 'core';
    if (lowerName.includes('multisig') || lowerName.includes('treasury') ||
        lowerName.includes('founder') || lowerName.includes('marketing') ||
        lowerName.includes('community') || lowerName.includes('reward')) return 'multisig';
    if (lowerName.includes('charity') || lowerName.includes('donation') ||
        lowerName.includes('gitcoin') || lowerName.includes('dao')) return 'charity';
    if (lowerName.includes('bridge') || lowerName.includes('helper')) return 'utility';
    if (lowerName.includes('uniswap') || lowerName.includes('sushiswap') ||
        lowerName.includes('aerodrome') || lowerName.includes('liquidity') ||
        lowerName.includes('lptoken') || lowerName.includes('setup')) return 'liquidity';
    return 'other';
};
